import { makeStyles } from "@material-ui/core/styles";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableFooter from "@material-ui/core/TableFooter";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { CSSProperties } from "@material-ui/styles";
import ResponsiveTable from "@saleor/components/ResponsiveTable";
import Skeleton from "@saleor/components/Skeleton";
import TableCellHeader from "@saleor/components/TableCellHeader";
import TablePagination from "@saleor/components/TablePagination";
import { maybe, renderCollection } from "@saleor/misc";
import { ListProps } from "@saleor/types";
import React from "react";
import { FormattedMessage } from "react-intl";

import { statusFormatter } from "../../../utils/misc";
import { StoresReport_storeDetails_edges_node } from "../../types/StoresReport";
const useStyles = makeStyles(
  theme => {
    const overflowing: CSSProperties = {
      overflow: "hidden",
      textOverflow: "ellipsis"
    };
    return {
      colMedium: {
        overflowing,
        width: "12em",
        [theme.breakpoints.down("md")]: {
          width: "auto"
        }
      },
      colNarrow: {
        overflowing,
        width: "8em",
        [theme.breakpoints.down("md")]: {
          width: "auto"
        }
      },
      colRow: {
        "& th": {
          fontWeight: 600 as 600,
          paddingBottom: theme.spacing(1),
          paddingTop: theme.spacing(1)
        }
      },
      colWide: {
        overflowing,
        width: "16em",
        [theme.breakpoints.down("md")]: {
          width: "auto"
        }
      },
      table: {
        tableLayout: "fixed"
      },
      tableRow: {
        cursor: "pointer"
      }
    };
  },
  { name: "StoresList" }
);

export interface StoresListProps extends ListProps {
  stores: StoresReport_storeDetails_edges_node[];
}

export const StoresList: React.FC<StoresListProps> = ({
  stores,
  onNextPage,
  onPreviousPage,
  onRowClick,
  onUpdateListSettings,
  pageInfo,
  settings,
  disabled
}) => {
  const colNum = 7;
  const classes = useStyles({});

  return (
    <>
      <ResponsiveTable className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCellHeader className={classes.colWide}>
              <FormattedMessage defaultMessage="Mall" />
            </TableCellHeader>
            <TableCellHeader className={classes.colWide}>
              <FormattedMessage defaultMessage="Brand" />
            </TableCellHeader>
            <TableCellHeader className={classes.colWide}>
              <FormattedMessage defaultMessage="Legal Name" />
            </TableCellHeader>
            <TableCellHeader className={classes.colWide}>
              <FormattedMessage defaultMessage="Store Type" />
            </TableCellHeader>
            <TableCellHeader className={classes.colMedium}>
              <FormattedMessage defaultMessage="Store Status" />
            </TableCellHeader>
            <TableCellHeader className={classes.colWide}>
              <FormattedMessage defaultMessage="Contract" />
            </TableCellHeader>
            <TableCellHeader className={classes.colWide}>
              <FormattedMessage defaultMessage="Rental Type" />
            </TableCellHeader>
          </TableRow>
        </TableHead>
        <TableFooter>
          <TableRow>
            <TablePagination
              colSpan={colNum}
              settings={settings}
              hasNextPage={
                pageInfo && !disabled ? pageInfo.hasNextPage : undefined
              }
              onNextPage={onNextPage}
              onUpdateListSettings={onUpdateListSettings}
              hasPreviousPage={
                pageInfo && !disabled ? pageInfo.hasPreviousPage : undefined
              }
              onPreviousPage={onPreviousPage}
            />
          </TableRow>
        </TableFooter>
        <TableBody>
          {stores &&
            renderCollection(
              stores,
              stores => (
                <TableRow
                  className={!!stores ? classes.tableRow : undefined}
                  hover={!!stores}
                  key={stores ? stores.id : "skeleton"}
                  onClick={
                    stores
                      ? onRowClick(btoa(`TenantPrivate:${atob(stores.id)}`))
                      : undefined
                  }
                >
                  <TableCell>
                    {maybe<React.ReactNode>(
                      () => stores.mall_name,
                      <Skeleton />
                    )}
                  </TableCell>
                  <TableCell>
                    {maybe<React.ReactNode>(
                      () => stores.brand_name,
                      <Skeleton />
                    )}
                  </TableCell>
                  <TableCell>
                    {maybe<React.ReactNode>(
                      () => stores.legal_name,
                      <Skeleton />
                    )}
                  </TableCell>
                  <TableCell>
                    {maybe<React.ReactNode>(
                      () => stores.store_type,
                      <Skeleton />
                    )}
                  </TableCell>
                  <TableCell>
                    {maybe<React.ReactNode>(
                      () => statusFormatter(stores?.store_status),
                      <Skeleton />
                    )}
                  </TableCell>
                  <TableCell>
                    {maybe<React.ReactNode>(
                      () => stores.contract_id,
                      <Skeleton />
                    )}
                  </TableCell>

                  <TableCell>
                    {maybe<React.ReactNode>(
                      () => stores.rental_type,

                      <Skeleton />
                    )}
                  </TableCell>
                </TableRow>
              ),
              () => (
                <TableRow>
                  <TableCell colSpan={colNum}>
                    <FormattedMessage defaultMessage="No Stores found" />
                  </TableCell>
                </TableRow>
              )
            )}
        </TableBody>
      </ResponsiveTable>
    </>
  );
};

export default StoresList;
